// View Orders → order-management?order_status=payment_verified&page=1&searchEmId={em_id}

import { PATHS } from '../../../routes/constants';

// View Invoices → /invoice-management?page=1&searchEmId={em_id}

// View Fiscal reports →  /fiscal-reports?page=1searchEmId={em_id}  NO Additional filters to be applied!

//  View Order Errors → /error-correction?page=1&search={full_name}

// View Subscription change requests → /monthly-fee?page=1&searchEmId={em_id}
type TEmManagementAction = {
	name: string;
	path: string | null;
};

export const emManagementActions = (emId: number, fullName: string, showActivateEuDdp: boolean) => {
	const actions: TEmManagementAction[] = [
		{
			name: 'View Orders',
			path: `${PATHS.ORDER_MANAGEMENT_PAGE}?order_status=payment_verified&page=1&searchEmId=${emId}`,
		},
		{
			name: 'View Invoices',
			path: `${PATHS.INVOICE_MANAGEMENT_PAGE}?page=1&searchEmId=${emId}`,
		},
		{
			name: 'View Fiscal reports',
			path: `${PATHS.FISCAL_REPORTS_PAGE}?page=1&searchEmId=${emId}`,
		},
		{
			name: 'View Order Errors',
			path: `${PATHS.ERROR_CORRECTIONS_PAGE}?page=1&search=${fullName}`,
		},
		{
			name: 'View Subscription change requests',
			path: `${PATHS.MONTHLY_FEE_PAGE}?page=1&searchEmId=${emId}`,
		},
		{
			name: 'View VAT corrections',
			path: `${PATHS.EM_VAT_CORRECTIONS_PAGE}?f-scheme=ioss&page=1&searchEmId=${emId}`,
		},
		{
			name: 'View PRP settings',
			path: `${PATHS.PRP_PAGE}?searchEmId=${emId}`,
		},
		{
			name: 'Send SMS',
			path: null,
		},
		{
			name: 'Generate link for uploading file',
			path: null,
		},
		// {
		// 	name: 'Activate EU DDP',
		// 	path: null,
		// },
	];
	if (showActivateEuDdp) {
		actions.push({
			name: 'Activate EU DDP',
			path: null,
		});
	}
	return actions;
};
